var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "profile_modal",
      attrs: {
        size: "lg",
        bodyClass: "p-0",
        "no-close-on-backdrop": true,
        "hide-header": true,
        dialogClass: _vm.dialog_class_draw,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "outline-danger" },
                  on: {
                    click: function ($event) {
                      return close()
                    },
                  },
                },
                [_vm._v("\n            Close Modal\n        ")]
              ),
            ]
          },
        },
        {
          key: "modal-footer",
          fn: function ({ close }) {
            return [
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary waves-effect waves-themed",
                    attrs: { type: "button" },
                    on: { click: _vm.close_mod },
                  },
                  [_vm._v("\n                Закрити\n            ")]
                ),
              ]),
            ]
          },
        },
      ]),
      model: {
        value: _vm.is_show_modal,
        callback: function ($$v) {
          _vm.is_show_modal = $$v
        },
        expression: "is_show_modal",
      },
    },
    [
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "panel mb-0 border-bottom-0 shadow-none",
          attrs: { id: "panel_user_list" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0",
            },
            [
              _vm.cur_item.id > 0
                ? _c("h2", [
                    _c("span", { staticClass: "fw-300" }, [
                      _vm._v(
                        "ID:" +
                          _vm._s(this.cur_item.id) +
                          " | " +
                          _vm._s(this.cur_item.title)
                      ),
                    ]),
                  ])
                : _c("h2", [_vm._v("\n                -\n            ")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "panel-toolbar pr-3 pb-2 align-self-end" },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed",
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("i", { staticClass: "fal fa-times" })]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "panel-container show p-3" }, [
            _vm.cur_item.id > 0
              ? _c("div", { staticClass: "steps" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-row align-items-center p-2" },
                    [
                      _c(
                        "div",
                        { staticClass: "icon-stack display-3 flex-shrink-0" },
                        [
                          _c("i", {
                            staticClass:
                              "fal fa-circle icon-stack-3x opacity-100 color-primary-400",
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "fas fa-building icon-stack-1x opacity-100 color-primary-500",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "ml-3" }, [
                        _c("strong", [
                          _vm._v(
                            "\n                        Номер службової\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://office.imcagro.com.ua/docs/memorandum/" +
                                this.memorandum.id,
                              target: "_blank",
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(this.memorandum.number) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex flex-row align-items-center p-2" },
                    [
                      _c(
                        "div",
                        { staticClass: "icon-stack display-3 flex-shrink-0" },
                        [
                          _c("i", {
                            staticClass:
                              "fal fa-circle icon-stack-3x opacity-100 color-primary-400",
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "fas fa-calendar-day icon-stack-1x opacity-100 color-primary-500",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "ml-3" }, [
                        _c("strong", [
                          _vm._v(
                            "\n                        Дата:\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(
                          "\n                        " +
                            _vm._s(this.cur_item.mem_added) +
                            "\n                    "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex flex-row align-items-center p-2" },
                    [
                      _c(
                        "div",
                        { staticClass: "icon-stack display-3 flex-shrink-0" },
                        [
                          _c("i", {
                            staticClass:
                              "fal fa-circle icon-stack-3x opacity-100 color-primary-400",
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "fas fa-chalkboard-teacher icon-stack-1x opacity-100 color-primary-500",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "ml-3" }, [
                        _c("strong", [
                          _vm._v(
                            "\n                        Співробітник:\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(
                          "\n                        " +
                            _vm._s(this.cur_item.init_user) +
                            "\n                    "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  this.cur_item.hasOwnProperty("trip_from")
                    ? _c(
                        "div",
                        {
                          staticClass: "d-flex flex-row align-items-center p-2",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "icon-stack display-3 flex-shrink-0",
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "fal fa-circle icon-stack-3x opacity-100 color-primary-400",
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass:
                                  "fas fa-building icon-stack-1x opacity-100 color-primary-500",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "ml-3" }, [
                            _c("strong", [
                              _vm._v(
                                "\n                        з:\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(
                              "\n                        " +
                                _vm._s(this.cur_item.trip_from) +
                                "\n                    "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.cur_item.hasOwnProperty("trip_to")
                    ? _c(
                        "div",
                        {
                          staticClass: "d-flex flex-row align-items-center p-2",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "icon-stack display-3 flex-shrink-0",
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "fal fa-circle icon-stack-3x opacity-100 color-primary-400",
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass:
                                  "fas fa-calendar-day icon-stack-1x opacity-100 color-primary-500",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "ml-3" }, [
                            _c("strong", [
                              _vm._v(
                                "\n                        до:\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(
                              "\n                        " +
                                _vm._s(this.cur_item.trip_to) +
                                "\n                    "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.cur_item.hasOwnProperty("car")
                    ? _c(
                        "div",
                        {
                          staticClass: "d-flex flex-row align-items-center p-2",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "icon-stack display-3 flex-shrink-0",
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "fal fa-circle icon-stack-3x opacity-100 color-primary-400",
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass:
                                  "fas fa-car-side icon-stack-1x opacity-100 color-primary-500",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "ml-3" }, [
                            _c("strong", [
                              _vm._v(
                                "\n                        Транспорт:\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(
                              "\n                        " +
                                _vm._s(this.cur_item.car.title) +
                                "\n                    "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex flex-row align-items-center p-2" },
                    [
                      _c(
                        "div",
                        { staticClass: "icon-stack display-3 flex-shrink-0" },
                        [
                          _c("i", {
                            staticClass:
                              "fal fa-circle icon-stack-3x opacity-100 color-primary-400",
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "fas fa-envelope-open-text icon-stack-1x opacity-100 color-primary-500",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "ml-3" }, [
                        _c("strong", [_vm._v("Опис:")]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(_vm.memorandum.pre_text),
                          },
                        }),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }